import { render, staticRenderFns } from "./MessageExcerpt.vue?vue&type=template&id=45c3df12&"
import script from "./MessageExcerpt.vue?vue&type=script&lang=js&"
export * from "./MessageExcerpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports